import {
  errorCellRenderer,
  statusIconsRenderer,
} from "../components/flowTable";
import { FlowTableColumn } from "../components/flowTable/types";
import { ROUTER_MODES } from "./types";

export const routerColumns: FlowTableColumn[] = [
  { data: "name", header: "Nome", type: "text", width: 200 },
  {
    data: "mode",
    header: "Modo",
    type: "dropdown",
    source: ROUTER_MODES,
    width: 95,
  },
  { data: "sourceIp", header: "IP de origem", type: "text", width: 115 },
  {
    data: "mostragemIpv4",
    header: "Amostragem IPv4",
    type: "text",
    width: 100,
  },
  {
    data: "mostragemIpv6",
    header: "Amostragem IPv6",
    type: "text",
    width: 100,
  },
  { data: "snmpIp", header: "IP SNMP", type: "text", width: 115 },
  {
    data: "snmpCommunity",
    header: "Comunidade SNMP",
    type: "text",
    width: 130,
  },
  { data: "snmpPort", header: "Porta SNMP", type: "text", width: 95 },
];

export const routerMassColumns: FlowTableColumn[] = [
  ...routerColumns.map((column) => ({
    ...column,
    renderer: errorCellRenderer,
  })),
  {
    data: "Status",
    header: "Status",
    type: "text",
    readOnly: true,
    width: 80,
    renderer: statusIconsRenderer,
  },
];
